module.exports = __webpack_public_path__ + "img/rtf.3198faa8.svg";